//
//
//
//
//
//
//
//

export default {
    name: "jiangzhuang",
  data(){
    return{
      jiangzhuang:[],
    }
  },
  created() {
      this.axios.post('/xcx/User/certificate').then(res=>{
        this.jiangzhuan=res.data.data;
      })
  }

}



// WEBPACK FOOTER //
// ./src/components/jiangzhuang/jiangzhuang.vue